import { v4 as uuidv4 } from 'uuid';
import ScanBoxView from './ScanBoxView';
import { KizBoxInventorySvedPluginSettings } from './KizBoxInventorySvedPluginSettings';

export const KizBoxInventorySvedTab = (): ITab => {
    return {
        id: uuidv4(),
        title: "Короб",
        view: {
            content: KizBoxInventorySvedPluginSettings
                ? <ScanBoxView gridId={uuidv4()} plugin={KizBoxInventorySvedPluginSettings} />
                : <p> Справочник не настроен </p>
        }
    }
}

export default KizBoxInventorySvedTab